import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterContainer = styled.footer`
  background-color: #333;
  width: 100vw;
`;

export const FooterWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    padding: 10px;
  }
`;

export const FooterLinksContainer = styled.div`
  display: flex;
`;

export const FooterLinksWrapper = styled.div`
  display: flex;
  width: 1000px;
  margin: 0 auto;
  padding: 10px 0;
  justify-content: space-between;

  @media screen and (max-width: 990px) {
    width: 100vw;
    justify-content: flex-start;
    max-gap: 24px;
    padding: 10px 20px;
  }

  @media screen and (max-width: 425px) {
    flex-direction: column;
    margin: 0 auto;
    width: 100%;
  }
`;

export const FooterLinksItems = styled.div`
  display: flex;
  flex-direction: column;
  color: #2f5;
  width: 100%;

  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 10px 0;
    width: 100%;
  }
`;

export const FooterLinkTitle = styled.h2`
  font-size: 16px;
  letter-spacing: 3px;
  margin-bottom: 4px;
  @media screen and (max-width: 990px) {
    font-size: 14px;
  }

  @media screen and (max-width: 425px) {
    font-size: 18px;
  }
`;

export const FooterLink = styled.p`
  color: #fff;
  letter-spacing: 2px;
  text-decoration: none;
  margin-bottom: 0.2rem;
  font-size: 12px;

  @media screen and (max-width: 990px) {
    font-size: 10px;
  }

  @media screen and (max-width: 425px) {
    font-size: 14px;
  }
`;

export const FooterLinkRow = styled.p`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 4px;
  color: #fff;
  letter-spacing: 2px;
  text-decoration: none;
  margin-bottom: 0.2rem;
  font-size: 12px;
  @media screen and (max-width: 990px) {
    font-size: 10px;
  }

  @media screen and (max-width: 425px) {
    font-size: 14px;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;
  
  @media screen and (max-width: 768px) {
    margin: 0;
    justify-content: space-around;
  }
`;

export const SocialLogo = styled(Link)`
  color: #2f5;
  justify-self: start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: bold;
  text-decoration: none;
  @media screen and (max-width: 768px) {
    font-size: 1em;
    margin-bottom: 5px;
  }
`;

export const WebsiteRight = styled.small`
  color: #fff;
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 140px;
`;

export const SocialIconsLink = styled.a`
  color: #fff;
  font-size: 24px;
  &:hover {
    color: #2f5;
    transition: 0.3s ease-out;
  }
  @media screen and (max-width: 620px) {
    font-size: 20px;
  }
`;
